(ns manage.content-configuration-page.view.core
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Fade$default" :as Fade]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/controls/watch.svg$default" :as Watch]
            [common.flags :refer [use-flag]]
            [common.util :as util]
            [common.widgets.content-function-version-selector
             :as cfn-version-selector]
            [common.widgets.page :as page]
            [linked.core :as l]
            [manage.adset-preview-page.view :refer [adset-preview-page]]
            [manage.adset-template-page.view.templates-panel :as tp]
            [manage.adset.view.page-header :as adset-page-header]
            [manage.content-configuration-page.view.content
             :as content
             :refer [create-draft-button delete-draft-button publish-button]]
            [manage.content-configuration-page.view.save
             :refer [unsaved-transactions]]
            [manage.export-table.view :as export-table]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui templates-tab []
  ($ page/content-padding
     ($ tp/templates-panel)))

(defui content-tab []
  (let [preview-href (use-subscribe [:resource.adset/rules-preview-url])
        more-save-controls? (use-flag :content-function-save-controls)
        autosave-disabled? (use-subscribe [:page.content-configuration/autosave-disabled])
        save-available? (not (use-subscribe [:page.content-configuration/save-available?]))
        validation-disabled? (use-subscribe [:page.content-configuration/validation-disabled])
        os-enabled (use-subscribe [:common.os/enabled])]
    ($ :<>
       ($ Stack
          {:direction "row"
           :justifyContent "space-between"
           :alignItems "center"
           :sx (util/spread-obj #js {:px 3 :py 1}
                                (when os-enabled
                                  page/wpp-os-content-padding-sx))}
          ($ Stack
             {:direction "row"
              :gap 2}
             ($ cfn-version-selector/button-group
                {:on-change #(rf/dispatch [:resource.content-function-version/activate-version %])})
             ($ publish-button)
             ($ create-draft-button)
             ($ delete-draft-button))
          ($ Stack
             {:direction "row"
              :gap 2}
             (when more-save-controls?
               ($ :<>
                  ($ Stack
                     {:direction "row"
                      :alignItems "center"
                      :gap 1}
                     ($ Switch
                        {:checked (or validation-disabled? false)
                         :onChange #(rf/dispatch [:page.content-configuration/set-validation-disabled (not validation-disabled?)])})
                     ($ Typography {:component "span"}
                        "Disable Validation"))
                  ($ Stack
                     {:direction "row"
                      :alignItems "center"
                      :gap 1}
                     ($ Switch
                        {:checked (or autosave-disabled? false)
                         :disabled (and (not save-available?) autosave-disabled?)
                         :onChange #(rf/dispatch [:page.content-configuration/set-autosave-disabled (not autosave-disabled?)])})
                     ($ Typography {:component "span"}
                        "Disable autosave"))
                  (when autosave-disabled?
                    ($ Button
                       {:variant "contained"
                        :sx #js {:height 35 :width 100}
                        :disabled save-available?
                        :onClick #(rf/dispatch [:page.content-configuration/save-cf])}
                       "Save"))))
             ($ Button
                {:variant "contained"
                 :href preview-href
                 :startIcon ($ Watch)}
                "Preview")))
       ($ unsaved-transactions)

       ($ Stack
          {:sx (util/spread-obj
                #js {:flex 1
                     :overflow "hidden"}
                (when os-enabled
                  (util/spread-obj page/wpp-os-content-padding-sx
                                   ;; Hack to offset padding on rules list.
                                   #js {:ml -3})))}
          ($ content/view)))))

(defui export-tab []
  ($ page/content-padding
     {:sx #js {:overflow "hidden"}}
     ($ export-table/export-data-grid)))

(def tabs
  (l/map :templates
         {:label "Templates"
          :view templates-tab}

         :content
         {:label "Content"
          :view content-tab}

         :export
         {:label "Export"
          :view export-tab}))

(defui content-configuration-page [_]
  (let [url-context (use-subscribe [:url-context])
        view (use-subscribe [:router/handler-name])
        preview (= :adset/rules-preview view)
        close-preview (uix/use-callback
                       (fn []
                         (r.easy/navigate :adset/content-configuration {:path-params url-context
                                                                        :fragment "content"}))
                       [url-context])]
    (uix/use-effect (fn []
                      (rf/dispatch [:side-menu/default :placeholders]))
                    [])
    ($ :<>
       ($ page/page
          ($ adset-page-header/page-header
             {:tabs tabs})
          ($ page/active-tab
             {:tabs tabs
              :sx #js {:px 0 :pb 0 :overflow "hidden"}}))

       ($ Fade
          {:in (boolean preview)
           :unmountOnExit true}
          ($ adset-preview-page {:onClose close-preview})))))
